import { put, takeLatest } from 'redux-saga/effects';
import { getServiceProvider, IServiceProvider } from '../../../services';
import actions from '../actions';

const reauthenticateSaga = takeLatest(actions.reauthenticate.request.type, function* ({
  payload: password,
}: ReturnType<typeof actions.reauthenticate.request>) {
  const serviceProvider: IServiceProvider = yield getServiceProvider();
  const authService = yield serviceProvider.getAuthService();

  try {
    yield authService.reauthenticate(password);
    yield put(actions.reauthenticate.success());
  } catch (e) {
    yield put(actions.reauthenticate.failure(e));
    serviceProvider.analyticsService.logError(e);
  }
});

const sagas = [reauthenticateSaga];

export default sagas;
